var _path, _defs, _path2, _path3, _path4, _rect, _path5, _path6, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnagitScreencastLogo = props => /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SnagitScreencastLogo_svg__a)",
  d: "M18.047 0H1.953A1.953 1.953 0 0 0 0 1.953v16.094C0 19.126.874 20 1.953 20h16.094A1.953 1.953 0 0 0 20 18.047V1.953A1.953 1.953 0 0 0 18.047 0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SnagitScreencastLogo_svg__a",
  x1: 10,
  x2: 10,
  y1: 0,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE7B2E"
}))))), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  x: 5,
  y: 2.5,
  fill: "none",
  viewBox: "0 0 12 16"
}, props), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.675 12.028.029 8.254A.018.018 0 0 0 0 8.27v6.793a.438.438 0 0 0 .684.362z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCE2C9",
  d: "M2.51 6.745 0 8.236l5.675 3.791 2.327-1.584z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.06 7.638.684.576A.438.438 0 0 0 0 .938v4.149a.02.02 0 0 0 .008.014l7.984 5.334.01.003.01-.003 3.047-2.075a.437.437 0 0 0 0-.722"
}))), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  x: 10,
  y: 10,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "url(#SnagitScreencastLogo_svg__b)",
  rx: 2.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.653 2.384a.3.3 0 0 1 .223-.092h9.276a.3.3 0 0 1 .223.096.32.32 0 0 1 .083.21.3.3 0 0 1-.09.21l-2.741 2.514a.3.3 0 0 1-.209.095H3.75zM6.84 14.375a.3.3 0 0 0-.209.086l-2.791 2.52a.3.3 0 0 0-.09.21.33.33 0 0 0 .083.21c.057.064.139.1.223.099h9.275a.3.3 0 0 0 .209-.092l2.918-3.033zM3.75 8.333h9.598a.3.3 0 0 1 .208.092l2.902 3.033H6.86a.3.3 0 0 1-.208-.091z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.333 11.458h3.125v2.917h-3.125zM3.75 5.417h3.125v2.917H3.75z",
  opacity: 0.74
})), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SnagitScreencastLogo_svg__b",
  x1: 10,
  x2: 10,
  y1: 0,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68B0DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#468CC3"
}))))));
export default SvgSnagitScreencastLogo;